import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faAppleWhole,
  faBottleDroplet,
  faBowlFood,
  faBowlRice,
  faCarrot,
  faCheese,
  faDrumstickBite,
  faFrenchFries,
  faIceCream,
  faPizzaSlice,
} from '@fortawesome/pro-regular-svg-icons';

/**
 * Resolves a food composite's `icon` column to real artwork.
 *
 * Mirrors hydration-type-icons: the column holds a Font Awesome name in kebab
 * case ("bowl-rice"), chosen by whoever writes the seed migration. A lookup is
 * still needed because Font Awesome icons must be imported to be bundled —
 * there is no way to fetch one by name at runtime — so this whitelist is what
 * decides which icons ship.
 *
 * Unlike the drinks library, the composite set is closed and seeded by
 * migration, so in practice every name here has a row and every row has a name.
 * The fallback exists for the ordering between a migration and an app release,
 * not as a routine state.
 */
const ICONS_BY_NAME: Record<string, IconDefinition> = {
  'drumstick-bite': faDrumstickBite,
  'bowl-rice': faBowlRice,
  carrot: faCarrot,
  'apple-whole': faAppleWhole,
  'bowl-food': faBowlFood,
  cheese: faCheese,
  'bottle-droplet': faBottleDroplet,
  'ice-cream': faIceCream,
  'french-fries': faFrenchFries,
  'pizza-slice': faPizzaSlice,
};

export const COMPOSITE_FALLBACK_ICON = faBowlFood;

/** Every icon the map can yield — components pass this to the FA icon library. */
export const COMPOSITE_ICONS: IconDefinition[] = [...new Set(Object.values(ICONS_BY_NAME)), COMPOSITE_FALLBACK_ICON];

/** The icon names this build can draw — useful when writing the seed SQL. */
export const SUPPORTED_COMPOSITE_ICON_NAMES = Object.keys(ICONS_BY_NAME);

export function compositeIcon(icon: string | undefined | null): IconDefinition {
  if (!icon) return COMPOSITE_FALLBACK_ICON;
  return ICONS_BY_NAME[icon.trim().toLowerCase()] ?? COMPOSITE_FALLBACK_ICON;
}
